import { buildHead } from "@/lib/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/.lovable/oauth/consent")({
  head: () =>
    buildHead({
      title: "Authorise Access | LohaLink",
      description: "Approve or deny an application requesting access to your LohaLink account.",
      canonical: "/.lovable/oauth/consent",
      noindex: true,
    }),
  component: lazyRouteComponent(() => import("@/pages/OAuthConsent")),
});
